<style>
    input:disabled,
    select:disabled {
        cursor: no-drop;
    }

    input:disabled {
        color: #a8a8a8;
    }
</style>

<div class="add-item-dialog-header"
    style="padding: 30px 24px 0; display: flex; justify-content: space-between; align-items: center;">
    <h1 style="font-size: 24px;">
        Add Item Information
    </h1>
    <button (click)="closeWithoutAddItem()"><i class="fas fa-times" style="font-size: 24px; color: red;"></i></button>
</div>




<div mat-dialog-content>
    <form ngNativeValidate [formGroup]="addCustomsItemForm">
        <div class="row">
            <div class="col-12 col-lg-9">
                <label class="shippn-form-label">
                    Description of Item*
                </label>
                <div style=" position: relative;">
                    <input type="text" formControlName="description"
                        [ngClass]="{'shippn-border-red':addCustomsItemForm.get('description').touched && addCustomsItemForm.get('description').invalid}"
                        placeholder="Clothes; Dishware; etc" class="form-control form-control-sm shippn-input" (click)="startHTSContentSelection()" readonly>


                    <div class="content-hts-selection-b2b" *ngIf="contentHTSSelection == true"
                        [ngClass]="contentHTSSelection == true ? 'stage-in-b2b': 'stage-out-b2b'" cdkTrapFocus cdkTrapFocusAutoCapture>
                        <div class="content-hts-search-b2b">
                            <input type="text" class="form-control" [(ngModel)]="searchContentNameB2B"
                                [ngModelOptions]="{standalone: true}" placeholder="Search for contents" #searchElement cdkFocusInitial>
                        </div>
                        <div class="content-hts-list-b2b">
                            <ul *ngIf="(htsList | htsContentSearch:searchContentNameB2B) as htsListSearched;">
                                <li *ngFor="let htsContent of htsListSearched; let index = index;"
                                    (click)="selectHTSContent(htsContent)">
                                    {{htsContent.content}}
                                </li>
                                <li *ngIf="htsListSearched.length == 0">
                                    Please select the matching result from list
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-3">
                <label class="shippn-form-label">
                    Origin Country
                </label>
                <input type="text" formControlName="origin_country"
                    [ngClass]="{'shippn-border-red':addCustomsItemForm.get('origin_country').touched && addCustomsItemForm.get('origin_country').invalid}"
                    placeholder="2-letter Code, e.g. US" class="form-control form-control-sm shippn-input">
            </div>
        </div>
        <div class="row" style="margin-top: 30px; margin-bottom: 30px;">
            <div class="col-12 col-lg-3">
                <label class="shippn-form-label">
                    Quantity*
                </label>
                <input type="number" formControlName="quantity"
                    [ngClass]="{'shippn-border-red':addCustomsItemForm.get('quantity').touched && addCustomsItemForm.get('quantity').invalid}"
                    placeholder="##" class="form-control form-control-sm shippn-input">
            </div>
            <div class="col-12 col-lg-3">
                <label class="shippn-form-label">
                    Unit Weight(lbs)*
                </label>
                <input type="number" formControlName="weight"
                    [ngClass]="{'shippn-border-red':addCustomsItemForm.get('weight').touched && addCustomsItemForm.get('weight').invalid}"
                    placeholder="##" class="form-control form-control-sm shippn-input">
            </div>
            <div class="col-12 col-lg-3">
                <label class="shippn-form-label">
                    Unit Value*
                </label>
                <input type="number" formControlName="value"
                    [ngClass]="{'shippn-border-red':addCustomsItemForm.get('value').touched && addCustomsItemForm.get('value').invalid}"
                    placeholder="##" class="form-control form-control-sm shippn-input">
            </div>
            <div class="col-12 col-lg-3">
                <label class="shippn-form-label">
                    Currency*
                </label> 
                <div style=" position: relative;">
                    <i class="fas fa-chevron-down"
                      style="position: absolute; right: 12px; top: 9px;float: right; color: #a8a8a8; border-radius: 32%; padding: 7px; font-size: 12px;"
                      aria-hidden="true"></i>
                    <select formControlName="currency"
                      style="-webkit-appearance: none;-moz-appearance: none;appearance: none; margin-bottom: 5px; width: 100%; border-radius: 5px;background-color: transparent;height: 40px; position: relative; z-index: 2;cursor: pointer;"
                      class="form-control-sm"
                      [ngClass]="{'shippn-border-red':addCustomsItemForm.get('currency').touched && addCustomsItemForm.get('currency').invalid}">
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                    </select>
                </div>
                <!-- <input type="text" formControlName="currency"
                    [ngClass]="{'shippn-border-red':addCustomsItemForm.get('currency').touched && addCustomsItemForm.get('currency').invalid}"
                    placeholder="3-letter code, e.g. USD" class="form-control form-control-sm shippn-input" disabled> -->
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6">
                <label class="shippn-form-label">
                    Harmonized Tariff Schedule*
                </label>
                <div style=" position: relative;">
                    <input type="text" formControlName="hs_tariff_number"
                        [ngClass]="{'shippn-border-red':addCustomsItemForm.get('hs_tariff_number').touched && addCustomsItemForm.get('hs_tariff_number').invalid}"
                        placeholder="e.g. '610910' for Men's T-shirts"
                        class="form-control form-control-sm shippn-input" readonly>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <label class="shippn-form-label">
                    Product Identifier
                </label>
                <input type="text" formControlName="productIdentifier"
                    [ngClass]="{'shippn-border-red':addCustomsItemForm.get('productIdentifier').touched && addCustomsItemForm.get('productIdentifier').invalid}"
                    placeholder="SKU/UPC or other identifier" class="form-control form-control-sm shippn-input">
            </div>
        </div>
    </form>
</div>





<div mat-dialog-actions style="justify-content: flex-end;">
    <button mat-flat-button color="primary" class="shippn-mat-btn" (click)="onAddItem()" cdkFocusInitial>Add
        Item</button>
</div>